import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import {
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalDescription,
  ModalTitle,
} from '../../../../../../design-system/modal/modal';
import { XeroConnectedModalContent } from './xero-connected-modal-content';

type XeroConnectedModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const XeroConnectedModal = ({ isOpen, onClose }: XeroConnectedModalProps) => {
  return (
    <Modal open={isOpen} onOpenChange={onClose}>
      <ModalContent className="h-max w-[520px] p-7">
        <VisuallyHidden>
          <ModalTitle>Exclude sender</ModalTitle>

          <ModalDescription>Exclude sender</ModalDescription>
        </VisuallyHidden>

        <ModalCloseButton onClick={onClose} aria-label="Close modal" />

        <XeroConnectedModalContent onClose={onClose} />
      </ModalContent>
    </Modal>
  );
};
